import { Wrapper, Spinner, Title, Screen } from "./LoadingPage.styles";

export default function LoadingPage() {
  return (
    <Screen>
      <Wrapper>
        <Spinner />
        <Title>Loading... </Title>
      </Wrapper>
    </Screen>
  );
}
